module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-about container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.note && _vm.about) ? _c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-top": "0",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.about.image ? _vm.about.image.path : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box note color-gray-lighter-bg is-hidden-mobile"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.about) ? _c('div', {
    staticClass: "column content content-main is-left",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.about.title) + "\n        ")]), _vm._v(" "), (_vm.about.content) ? _c('markdown', {
    attrs: {
      "source": _vm.about.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "column content is-hidden-tablet",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "box note color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c62653","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 961
// module chunks = 1